import { extendVariants, Switch } from "@nextui-org/react";

const SpicySwitch = extendVariants(Switch, {
  variants: {
    variant: {
      primary: {
        thumb: "dark:bg-black h-[14px] min-w-[14px] max-w-[14px] mt-[0.5px] group-data-[selected=true]:ml-3.5 z-0",
        wrapper: "h-[20px] w-[32px] m-0 px-[0.15rem]",
      },
    },
  },
});

export default SpicySwitch;
